/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon, IconSizeMap } from "../../";
export function IconMoon(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M6.866.447a.75.75 0 0 1 .119.789 6.34 6.34 0 0 0-.526 2.538c0 3.522 2.863 6.38 6.4 6.38.575 0 1.13-.075 1.659-.216a.75.75 0 0 1 .88 1.024 7.902 7.902 0 0 1-7.248 4.744c-4.361 0-7.9-3.526-7.9-7.88 0-3.65 2.484-6.715 5.854-7.614a.75.75 0 0 1 .762.235Zm-1.75 1.759a6.378 6.378 0 0 0-3.366 5.62c0 3.521 2.863 6.38 6.4 6.38a6.397 6.397 0 0 0 5.128-2.563 7.996 7.996 0 0 1-.42.011c-4.36 0-7.9-3.526-7.9-7.88 0-.537.055-1.061.157-1.568Z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M11.18 1.506a1 1 0 0 1 .125 1.063 8.696 8.696 0 0 0-.855 3.776 8.735 8.735 0 0 0 10.829 8.482 1 1 0 0 1 1.14 1.404 10.736 10.736 0 0 1-9.683 6.094c-5.928 0-10.734-4.806-10.734-10.735 0-5.043 3.477-9.272 8.163-10.424a1 1 0 0 1 1.015.34Zm-2.43 2.31a8.735 8.735 0 1 0 10.787 13.258 10.33 10.33 0 0 1-.352.006c-5.929 0-10.735-4.807-10.735-10.735 0-.87.104-1.718.3-2.529Z\'/>'
  }];
  var iconSizeValue = props.size ? IconSizeMap[props.size] : props.iconSize;
  var closestSize = findClosestGlyphAvailable(iconList, iconSizeValue || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}

/**
 * @deprecated The name Experimental__IconMoon is deprecated and will be archived soon. Use IconMoon instead.
 */
export function Experimental__IconMoon(props) {
  return /*#__PURE__*/React.createElement(IconMoon, props);
}